<template>
  <modal ref="modal">
    <template v-slot:header>
       <div class="text-center"><a class="text-blue-800" href="https://www.toptal.com/" target="_blank">Toptal</a></div>
    </template>
    <div><p class="text-center">Developed dynamic email templating system and a web crawler to download, parse and upload data on to a server.</p>
      <br/>
      <div class="bg-gray-300 font-mono p-2">
    <p>- Used <a class="text-blue-500 hover:text-blue-800" href="https://en.wikipedia.org/wiki/Simple_Mail_Transfer_Protocol" target="_blank">SMTP</a>, <a class="text-blue-500 hover:text-blue-800" href="https://mailchimp.com/" target="_blank">Mail Chimp</a> and <a class="text-blue-500 hover:text-blue-800" href="https://www.ruby-lang.org/en/" target="_blank">Ruby</a> on <a class="text-blue-500 hover:text-blue-800" href="https://rubyonrails.org/" target="_blank">Rails</a> backend for the dynamic mailing system.</p></div>
    <div class="bg-gray-300 font-mono p-2">
    <p>- Used <a class="text-blue-500 hover:text-blue-800" href="https://github.com/puppeteer/puppeteer" target="_blank">Puppeteer</a> for the web crawler.</p></div>
    </div>
  </modal>
</template>
<script>
  import Modal from './Modal.vue'

  export default {
    components: {
      Modal
    },

    methods: {
      open () {
        this.$refs.modal.open()
      },
      close () {
        this.$refs.modal.close()
      }
    }
  }
</script>
<style>
  a {
    color:;
  }
</style>
